import gql from 'graphql-tag'
import { EntityFields, EnumFields } from '..'

export const RequirementTypeFragment = gql`
  fragment RequirementType on loans_requirement_type{
    ${EntityFields}
    ${EnumFields}
  }
`
